import { useEffect, useRef, useState } from "react";
import {
  useLargeScreenMediaQuery,
  useSmOrMdScreenMediaQuery,
} from "@/react/hooks/useMediaQuery";
import { CounterBadge } from "@circle-react/components/shared/CounterBadge";
import { usePunditUserContext } from "@circle-react/contexts";
import { roundedCount } from "@circle-react/helpers/notificationHelpers";
import { Tab } from "@circle-react-uikit/TabV2";
import { NotificationsList } from "./List";
import { TABS, useNotificationContext } from "./NotificationContext";
import { useNotificationsCount } from "./useHeaderNotificationsApi";

const MIN_TABS_CONTAINER_WIDTH = 478;
const DRAWER_WIDTH = 446;
export const Body = () => {
  const [tabsContainerWidth, setTabsContainerWidth] = useState(
    MIN_TABS_CONTAINER_WIDTH,
  );
  const { activeTab, setActiveTab, setNotificationCount, getTabLabel } =
    useNotificationContext();

  const { currentCommunity } = usePunditUserContext();
  const tabsContainerRef = useRef<HTMLDivElement>(null);

  const { data: counters } = useNotificationsCount(
    currentCommunity?.id,
    setNotificationCount,
  );

  const isSmallScreen = useSmOrMdScreenMediaQuery();
  const isMediumScreen = useLargeScreenMediaQuery();
  useEffect(() => {
    if (isSmallScreen) {
      setTabsContainerWidth(window.innerWidth);
    } else if (isMediumScreen) {
      setTabsContainerWidth(DRAWER_WIDTH);
    } else {
      if (tabsContainerRef.current) {
        if (tabsContainerRef.current.offsetWidth > MIN_TABS_CONTAINER_WIDTH) {
          setTabsContainerWidth(tabsContainerRef.current.offsetWidth);
        } else {
          setTabsContainerWidth(MIN_TABS_CONTAINER_WIDTH);
        }
      }
    }
  }, [isSmallScreen, isMediumScreen]);

  const getCounterBadgedElement = (count: number) => {
    if (count > 0) {
      return <CounterBadge count={roundedCount(count)} />;
    }

    return null;
  };

  const tabsUnreadNotificationsCountMap: any = {
    [TABS.INBOX]: getCounterBadgedElement(counters?.new_inbox_count),
    [TABS.MENTIONS]: getCounterBadgedElement(counters?.new_mentions_count),
  };

  return (
    <Tab.Group
      className="w-fit overflow-hidden"
      selectedIndex={Object.values(TABS).indexOf(activeTab)}
    >
      <div className="w-fit px-6" ref={tabsContainerRef}>
        <Tab.List>
          {Object.values(TABS).map(tab => (
            <Tab
              key={tab}
              className="text-sm"
              onClick={() => {
                setActiveTab(tab);
              }}
            >
              <div className="flex items-center gap-1">
                {getTabLabel(tab)}
                {tabsUnreadNotificationsCountMap[tab]}
              </div>
            </Tab>
          ))}
        </Tab.List>
      </div>
      <div className="border-primary w-full border-b" />
      <NotificationsList style={{ width: tabsContainerWidth }} />
    </Tab.Group>
  );
};
